import React from 'react';
import { motion } from 'framer-motion';
type ButtonProps = {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  onClick?: () => void;
};
const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  size = 'md',
  className = '',
  onClick,
  ...props
}) => {
  const baseStyles = 'inline-flex items-center justify-center rounded font-medium transition-all duration-200';
  const variantStyles = {
    primary: 'bg-toronto-blue text-white hover:bg-toronto-blue/90',
    secondary: 'bg-canada-red text-white hover:bg-canada-red/90',
    outline: 'bg-transparent border-2 border-toronto-blue text-toronto-blue hover:bg-toronto-blue/10'
  };
  const sizeStyles = {
    sm: 'text-sm px-3 py-1.5',
    md: 'px-5 py-2.5',
    lg: 'text-lg px-6 py-3'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${className}`} onClick={onClick} {...props} data-id="element-128">
      {children}
    </motion.button>;
};
export default Button;